var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.total > 0)?_c('div',{staticClass:"pagination"},[_c('i-page',{ref:"iPage",attrs:{"total":_vm.total,"page-size":_vm.pageSize,"current":_vm.page,"size":"small","show-elevator":""},on:{"on-change":_vm.pageChangeHandler}}),_vm._v(" "),_c('i-button',{attrs:{"type":"text"},on:{"click":_vm.confirmClickHandler}},[_vm._v("确定")])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f42c49e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagination.vue
// module id = null
// module chunks = 